import { reactive } from 'vue';

export const events = reactive({
    events: {},

    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(callback);
    },

    emit(eventName, payload) {
        if (this.events[eventName]) {
            this.events[eventName].forEach(callback => callback(payload));
        }
    },

    off(eventName, callback) {
        if (!this.events[eventName]) return;
        this.events[eventName] = this.events[eventName].filter(cb => cb !== callback);
    },
});
